export default __webpack_public_path__ + "static/media/logo_Adeo.8ab25107.png";